/* @flow */

import { Clipboard } from 'react-native';
import { find } from 'lodash/fp';

import { leaveReview } from '../auth/actions';
import bugsnagClient from '../../clients/bugsnag-client';
import {
  getAllTodos,
  scheduleNextTodoChange,
  forceSync,
} from '../todo/actions';
import { clipboardContentsSelector } from './selectors';
import { allTodosTransformedRaw } from '../todo/selectors';
import { isLoggedInSelector } from '../auth/selectors';
import { updateEvents } from '../calendar/actions';
import isInitialized from '../../observables/isInitialized';


export const requestReviewIfAppropriate = (): ThunkAction => (
  dispatch,
) => {
  dispatch(leaveReview(false));
};

export const updateClipboardIfAppropriate = () => async (
  dispatch: Dispatch,
  getState: () => Object,
) => {
  const contents = await Clipboard.getString(),
        state = getState();
  if (
    contents
      && contents !== 'null'
      && state.system.isInitComplete
      && clipboardContentsSelector(state) !== contents
      && !find((t) => t.title === contents, allTodosTransformedRaw(state))
  ) {
    dispatch({ type: 'CLIPBOARD_UPDATED', payload: { contents } });
  }
};

export const dismissClipboard = () => (dispatch: Dispatch) => {
  dispatch({ type: 'CLIPBOARD_DISMISSED' });
};

export const initializationComplete = () => (dispatch: Dispatch) => {
  bugsnagClient.leaveBreadcrumb('Redux init complete');
  dispatch({ type: 'INIT_COMPLETE' });
  dispatch(updateClipboardIfAppropriate());

  isInitialized.set(true);

  return dispatch(getAllTodos(false));
};

export const handleIsConnectedChange = (isConnected: boolean) => (
  dispatch: Dispatch,
) => {
  bugsnagClient.leaveBreadcrumb(`isConnected updated to ${isConnected}`, { isConnected });
  dispatch({ type: 'CONNECTIVITY_UPDATED', payload: isConnected });
};

export const handleConnectionChange = (connection: NetInfoConnection) => (
  dispatch: Dispatch,
) => {
  bugsnagClient.leaveBreadcrumb(`connection updated to ${connection}`, { connection });
  dispatch({ type: 'CONNECTION_UPDATED', payload: connection });
};

export const handleAppBecameInactive = () => (dispatch: Dispatch) => {
  dispatch(forceSync());
};

export const handleAppBecameActive = () => (
  dispatch: Dispatch,
  getState: () => Object,
) => {
  const state = getState(),
        isLoggedIn = isLoggedInSelector(state);

  if (state.system.isInitComplete) {
    dispatch(updateEvents());
    dispatch(requestReviewIfAppropriate());
  }

  if (isLoggedIn && state.system.isInitComplete) {
    dispatch(getAllTodos(false));
  } else {
    dispatch(scheduleNextTodoChange());
  }
  dispatch(updateClipboardIfAppropriate());
};
